<template lang="pug">
  .wrapper.challenge-parent
    .challenge-parent__title-container
      challenge-title.challenge-parent__title {{title}}
      lei-btn.challenge-parent__button(type="round" size="sm" @click="openModal")
        font-awesome-icon.challenge-parent__button-icon(:icon="buttonAction" size="1x", regular)
        span.challenge-parent__button-text {{buttonText}}
    collapsed-data-sections(:sections="relationshipSections")
</template>
<script>
import { mapGetters, mapMutations, } from 'vuex'
import {
  TOGGLE_CHALLENGE_RELATIONSHIP_MODAL,
  SET_PARENT_TYPE,
  SET_RELATIONSHIP_DETAILS,
} from '@/store/modules/record/modules/challenge/mutations-types'
import record from '@/constants/tooltips/record'
import ChallengeParentMixin from '@/mixins/challenge-parent'
import CollapsedDataSections from '@/components/record-details/CollapsedDataSections'
import { getCompanyName, isAvailableExc, } from '@/store/modules/record/helpers/parsing'
import ChallengeTitle from '@/components/challenge-components/ChallengeTitle'
import LeiBtn from '../lei-components/LeiBtn'

export default {
  components: {
    ChallengeTitle,
    CollapsedDataSections,
    LeiBtn,
  },
  mixins: [ ChallengeParentMixin, ],
  data () {
    return {
      detailsData: [],
      periodData: [],
      tooltips: record,
      comment: '',
      anotherParent: {
        lei: '',
        name: '',
      },
    }
  },
  computed: {
    title () {
      if (this.parent) return this.parentTitle
      else if (isAvailableExc(this.exception)) return this.exceptionTitle
      else return this.defaultTitle
    },
    buttonText () {
      return `${this.parent ? 'Remove' : 'Add'} ${this.defaultTitle}`
    },
    buttonAction () {
      return this.parent ? 'trash-alt' : 'plus-circle'
    },
    parentTitle () {
      return `${this.defaultTitle}: ${this.parentEntity}`
    },
    parentEntity () {
      return this.parent ? `${this.parent.lei} ${getCompanyName(this.parent)}` : ''
    },
    exceptionTitle () {
      return `${this.defaultTitle}: ${this.exception.reason}`
    },
    relationshipDetails () {
      return this.getParentRelationshipDetails(this.type, this.parentEntity)
    },
    registrationDetails () {
      return this.getParentRegistrationDetails(this.type)
    },
    relationshipPeriods () {
      return this.getParentRelationshipPeriods(this.type)
    },
    sectionsAreDisabled () {
      return this.getCurrentRelationshipTypes[this.type] === 'exception' || this.getCurrentRelationshipTypes[this.type] === 'nonExisting'
    },
    getToolTip () {
      if (this.type === 'directParent' || this.type === 'ultimateParent') return this.tooltips.l2RelationshipDetails
      if (this.type === 'headOffice') return this.tooltips.l2RelationshipDetailsBranch
      return this.tooltips.l2RelationshipDetailsFund
    },

    relationshipSections () {
      //  Relationship Periods sections is disabled until data is available
      // const periodsDisabledMsg = !this.sectionsAreDisabled
      //   ? undefined
      //   : 'Relationship periods cannot be challenged if the relationship is not reported.'

      const registration = this.sectionsAreDisabled ? [] : [
        {
          title: 'Registration Details',
          data: this.registrationDetails,
          tip: this.tooltips.l2RegistrationDetails,
        },
      ]
      return [
        {
          title: 'Relationship Details',
          data: this.relationshipDetails,
          tableLayout: 'rel-details',
          type: this.type,
          tip: this.getToolTip,
        },

        //  Relationship Periods sections is disabled until data is available

        // {
        //   title: 'Relationship Periods',
        //   data: this.relationshipPeriods,
        //   tableLayout: 'intervals',
        //   tip: this.tooltips.l2RelationshipPeriods,
        //   sectionDisabledMsg: periodsDisabledMsg,
        // },
        ...registration,
      ]
    },

    ...mapGetters('record', [
      'getParentException',
      'getParentRelationshipDetails',
      'getParentRegistrationDetails',
      'getParentRelationshipPeriods',
      'getCurrentRelationshipTypes',
    ]),
  },
  methods: {
    changeRelationshipType () {
      this.setRelationshipType({
        type: this.type,
      })
    },
    openModal (){
      const action = this.parent ? 'exception' : 'parent'
      this.changeRelationshipType()
      this.setRelationshipDetails({
        data: this.relationshipDetails,
      })
      this.toggleRelationshipModal(action)
    },
    ...mapMutations('record/challenge', {
      toggleRelationshipModal: TOGGLE_CHALLENGE_RELATIONSHIP_MODAL,
      setRelationshipType: SET_PARENT_TYPE,
      setRelationshipDetails: SET_RELATIONSHIP_DETAILS,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .challenge-parent
    margin 50px 0 0
    &__title-container
      width 100%
      display flex
      margin-bottom 20px
      justify-content space-between
      align-items center
      @media (max-width: $mobile-l)
        flex-direction column
    &__title
      margin-bottom 0 !important
      width 50% !important

    &__button
      &-icon
        color $black-color-light
      &-text
        margin-left 15px
      @media (max-width: $tablet)
        width auto !important
        .challenge-parent__button-text
          margin-left 10px
  @media (max-width: $mobile-l)
    .challenge-parent
      &__title-container
        flex-direction column
      &__title
        margin-bottom 20px !important
        width 100% !important
      &__button
        align-self flex-end

</style>



// WEBPACK FOOTER //
// src/components/challenge-components/ChallengeParent.vue